const config = {
  baseUrl: process.env.REACT_APP_SERVER_URL,
  modificationUseMainApi: process.env.REACT_APP_MODIFICATION_USE_MAIN_API === "true",
};
export default config;
